// import './sections/main-product.js';
import '../sections/periodic_table_eleven.js';
import '../sections/video.js';
